(function($, undefined) {
	'use strict';
	var utils;
	var viewportState;
	var prevViewportState;
	var siteOverlay;
	var tableDetailRows;
	var tableDetailBtn;
	var tableDetailCloseBtn;
	
	var init = function() {
		utils = Fw.component.models().utils;
		siteOverlay = $('.site-overlay');
		tableDetailRows = $('.table__tr_detail_close, .table__tr_detail_open');
		tableDetailBtn = $('.table__btn_detail_close, .table__btn_detail_open');
		tableDetailCloseBtn = $('.table-detail-content__close-btn', tableDetailRows);
		
		tableDetailBtn.on('click', toggleTableDetail);
		siteOverlay.on('click', closeItems);
		tableDetailCloseBtn.on('click', closeTableDetail);
		
		$('#confirm-delete-account-popup .btn_confirm').on('click', deleteTableItem);
		
		viewportState = utils.getViewportState();
		prevViewportState = viewportState;
		$(window).resize(function() {
			viewportState = utils.getViewportState();
			var changedViewportState = viewportState != prevViewportState;
			
			if (viewportState != "desktop" && changedViewportState) {
				if (tableDetailRows.filter('.table__tr_detail_open').length > 0) {
					siteOverlay.addClass('visible');
				}	
			} 
			else if (changedViewportState) {
				siteOverlay.removeClass('visible');
			}
			
			prevViewportState = viewportState;
		});
	};
	
	
	
	var toggleTableDetail = function() {
		var btn = $(this);
		var tableRow = btn.closest('.table__tr');
		var nextTableRow = tableRow.next();
		
		if (btn.hasClass('table__btn_detail_close')) {
			btn.removeClass('table__btn_detail_close').addClass('table__btn_detail_open');
		} else {
			btn.removeClass('table__btn_detail_open').addClass('table__btn_detail_close');
		}
		
		tableRow.toggleClass('table__tr_detail-prev_open');
		
		if (nextTableRow.hasClass('table__tr_detail_close')) {
			nextTableRow.removeClass('table__tr_detail_close').addClass('table__tr_detail_open');
		} else {
			nextTableRow.removeClass('table__tr_detail_open').addClass('table__tr_detail_close');
		}
		
		if (utils.isSM()) {
			$('.table__detail-content', nextTableRow).show();
			siteOverlay.toggleClass('visible');
		} 
		else {
			$('.table__detail-content', nextTableRow).slideToggle(300);
		}
	};
	
	var closeItems = function() {
		var doClose = false;
		if ($('.table__tr').hasClass('visible')) {
			$('.table__tr').removeClass('visible');
			doClose = true;
		}
		
		if (doClose) {
			$(this).removeClass('visible');
			$('.table__detail-btn.selected').removeClass('selected');
		}
	};
	
	var closeTableDetail = function() {
		var btn = $(this);
		var tableRow = btn.closest('.table__tr');
		var prevTableRow = tableRow.prev();
		var tableDetailToggleBtn = $('.table__btn_detail_open', prevTableRow);
		
		tableDetailToggleBtn.removeClass('table__btn_detail_open').addClass('table__btn_detail_close');
		
		prevTableRow.removeClass('table__tr_detail-prev_open');
		tableRow.removeClass('table__tr_detail_open').addClass('table__tr_detail_close');
		
		if (utils.isSM()) {
			$('.table__detail-content', tableRow).hide();
			tableRow.removeClass('visible');
			siteOverlay.removeClass('visible');
		} 
		else {
			$('.table__detail-content', tableRow).slideUp(300);
		}
	};
	
	var deleteTableItem = function() {
		var btn = $(this);
		
		siteOverlay.addClass('visible');
		var type = btn.attr('data-type');
		var id = btn.attr('data-id');
		var itemsToRemove = $("." + id).not('.no-remove');
		var hasPopup = btn.closest('.popup-outer').length > 0;
		
		if (type && type.length > 0 && id && id.length > 0) {
			if (type === "person") {
				utils.deletePerson(id, function(response) {
					if (response.indexOf('success') !== -1) {
						itemsToRemove.remove();
					}
					siteOverlay.removeClass('visible');
					if (hasPopup) {
						popupUtils.closePopupById(btn.closest('.popup-outer').attr('id'));
					}
				});
			} 
			else if (type === "gendata") {
				utils.deleteGenData(id, function(response) {
					if (response.indexOf('success') !== -1) {
						itemsToRemove.remove();
					}
					siteOverlay.removeClass('visible');
					if (hasPopup) {
						popupUtils.closePopupById(btn.closest('.popup-outer').attr('id'));
					}
				});
			} else {
				console.log('unrecognized data type: ' + type);
				siteOverlay.removeClass('visible');
			}
		}
		else {
			console.log('Unable to complete deletion: no id or type given');
			console.log('id: ' + id);
			console.log('type: ' + type);
			siteOverlay.removeClass('visible');
		}
	};

	$(window).ready(function() {
		init();
	});
	
})(jQuery);
